import { createFormFromSchema, ObservableForm } from "@corets/form"
import { object, string } from "@corets/schema"

export type SearchReflectionProcessingFormType = {
  keyword?: string
  address?: string
  phoneNumber?: string
}

export const createSearchReflectionProcessingForm = (
  data?: SearchReflectionProcessingFormType
): ObservableForm<SearchReflectionProcessingFormType, SearchReflectionProcessingFormType> => {
  const form = createFormFromSchema<SearchReflectionProcessingFormType>(
    object<SearchReflectionProcessingFormType>({
      keyword: string()
        .optional()
        .toDefault(data?.keyword || ""),
      address: string()
        .optional()
        .toDefault(data?.address || ""),
      phoneNumber: string()
        .optional()
        .toDefault(data?.phoneNumber || ""),
    })
  ).handler(async (form) => {
    return form.get()
  })

  return form
}
